import { Component, EventEmitter, OnInit } from '@angular/core';
import { AbstractControlComponent } from '../../abstract-control/abstract-control.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { FinancialYear } from 'taxtank-core';

@Component({
  selector: 'app-month-select',
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RxReactiveFormsModule
  ],
  templateUrl: './month-select.component.html',
  styleUrl: './month-select.component.scss'
})
export class MonthSelectComponent extends AbstractControlComponent<number> implements OnInit {
  changed: EventEmitter<number> = new EventEmitter();
  startMonth = FinancialYear.startMonthIndex;
  endMonth = FinancialYear.endMonthIndex;

  /**
   * our calendar goes from 5 to 6. so the problem is when we go 11,12,0,1,...
   */
  changeMonth(offset: 1 | -1): void {
    const month = this.ngControl.control.value;

    if (offset === -1 && month === 0) {
      this.ngControl.control.setValue(11);
    } else if (offset === 1 && month === 11) {
      this.ngControl.control.setValue(0);
    } else {
      this.ngControl.control.setValue(month + offset);
    }
  }
}
